import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  pCourseOptionsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    fontSize: theme.typography.fontSize,
  },
  pCourseOptionsTitle: {
    width: '100%',
    fontSize: 18,
    margin: 0,
  },
  pCourseOptionsSubtitle: {
    width: '100%',
    fontSize: 15,
    margin: 0,
  },
  pCourseOptionsDetails: {
    fontSize: theme.typography.fontSize,
    fontWeight: 'normal',
  },
});
